import logo from "@/assets/logo.png";
import { cn } from "@/lib/utils";

interface StrataLogoProps {
  className?: string;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
}

const sizeClasses = {
  xs: "h-3 w-3",
  sm: "h-4 w-4",
  md: "h-5 w-5",
  lg: "h-6 w-6",
  xl: "h-8 w-8",
};

export function StrataLogo({ className, size = "sm" }: StrataLogoProps) {
  return (
    <img 
      src={logo} 
      alt="Strata" 
      className={cn(sizeClasses[size], "object-contain", className)} 
    />
  );
}
